import { Badge } from './Badge';

interface Props {
  failLabel: string;
  successLabel: string;
  successCond: () => boolean;
  clickable?: boolean;
  onClick?: () => void;
}

export const BooleanBadge = (props: Props) => {
  const { failLabel, successLabel, successCond, clickable, onClick } = props;
  const className = clickable ? 'cursor-pointer' : '';

  if (successCond()) {
    return (
      <Badge
        label={successLabel}
        getColor={() => 'success'}
        className={className}
        onClick={onClick}
      />
    );
  }
  return (
    <Badge
      label={failLabel}
      getColor={() => 'error'}
      className={className}
      onClick={onClick}
    />
  );
};
